/**
 * Intent v1 — literal formatting tokens shared by the parser and the renderer.
 *
 * Both sides read these constants so a change to the document layout cannot break
 * the round trip by touching only one half.
 */
/** Fence that opens and closes the frontmatter block. */
export const INTENT_FRONTMATTER_FENCE = "---";
/** Level-1 heading that follows the frontmatter. */
export const INTENT_DOCUMENT_TITLE = "# Intent";
/** Marker emitted in place of a value when a slot is explicitly unknown. */
export const INTENT_UNKNOWN_MARKER = "_unknown_";
/** Prefix of the provenance line emitted for a filled slot that carries a source. */
export const INTENT_SOURCE_PREFIX = "source: ";
/** Body emitted for a playbook section whose slots have all gone unaddressed. */
export const INTENT_EMPTY_SECTION_PLACEHOLDER = "_No entries yet._";
/** Body emitted for the Open questions section when nothing is unknown. */
export const INTENT_NO_OPEN_QUESTIONS_PLACEHOLDER = "_None — every slot has an answer._";
/**
 * Draft status header. `{n}` is the number of slots without an answer and `{m}` the
 * total number of slots in the registry.
 */
export const INTENT_DRAFT_STATUS_TEMPLATE = "Status: DRAFT — agent-drafted from case text only; {n} of {m} slots unknown; a person must review before this is used.";
/** Build the draft status header for a given unanswered/total pair. */
export function draftStatusLine(unanswered, total) {
    return INTENT_DRAFT_STATUS_TEMPLATE.replace("{n}", String(unanswered)).replace("{m}", String(total));
}
//# sourceMappingURL=format.js.map